import { QRCodeSVG } from "qrcode.react";
import React, { Fragment, useState } from "react";
import customConfig from "../../config";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Popup from "../layout/Popup"; // Adjust the path based on your folder structure

const QRdisplay = ({ qrCodeUrl }) => {
  const [showInstructions, setShowInstructions] = useState(false);

  const handleInstructionsClick = (e) => {
    e.preventDefault();
    setShowInstructions(true);
  };

  const closeInstructions = () => {
    setShowInstructions(false);
  };

  return (
    <Fragment>
      <h2 className="center-align mfa-page-title">
        <span className="mfa-title-main">Scan this QR code to set up 2-Step</span>
        <span className="mfa-title-break">Authentication</span>
      </h2>
      <div className="row mb-0">
        <div className="input-field p-0 col s12 center-align">
          {qrCodeUrl ? (
            <QRCodeSVG value={qrCodeUrl} size={256} />
          ) : (
            <p>Loading QR Code...</p>
          )}
          <div style={{ marginTop: "10px" }}>
            <a href="#" onClick={handleInstructionsClick} style={{ color: "blue" }}>
              Need help?
            </a>
          </div>
        </div>
      </div>

      {showInstructions && (
        <Popup visible={showInstructions} notifyPopupClose={closeInstructions}>
          <div className="qr-popup-container">
            <h2>Set up 2-Step Authentication</h2>
            <ol>
              {customConfig.mfaSetupInstuctions.map((instruction, index) => (
                <li key={index}>{instruction}</li>
              ))}
            </ol>
          </div>
        </Popup>
      )}
    </Fragment>
  );
};

QRdisplay.propTypes = {
  qrCodeUrl: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  qrCodeUrl: state.auth.qrCodeUrl,
});

export default connect(mapStateToProps)(QRdisplay);
